import {WhatsappChat} from "./../../models/WhatsappChat";
import {WrapperFactory} from "./../../util/WrapperFactory";

let whatssappChatsApi = {
    async get(clientId, page=1, token, companyId, params=[], select= [], relations=[]){
        let response = await window.axios.get('/api/whatsappChat', {
            params:{
                api_token:token,
                company_logged:companyId,
                client_id:clientId,
                select:select,
                relationships:relations,
                page: page,
                ...params
            }
        });
        let wrapper = WrapperFactory.fromResponse(response.data)
        wrapper.transform(e=>new WhatsappChat(e));
        return wrapper
    },
    async getDates(clientId, token, companyId){
        let response = await window.axios.get('/api/whatsappChat/dates', {
            params:{
                api_token:token,
                company_logged:companyId,
                client_id:clientId,
            }
        });
        return response.data.map(d=>d.date)
    },
}

export default whatssappChatsApi